import { defineMessages } from 'react-intl'

export const errorMessages = defineMessages({
  requiredField: {
    defaultMessage: 'This field is required.',
    description: 'error',
  },
})
